'use strict';

var React = require('react');

var SvgEnvelopeIcon = function SvgEnvelopeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6 9.5a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5h-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 12.5a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.25 4a2.75 2.75 0 0 0-2.75 2.75v6.5a2.75 2.75 0 0 0 2.75 2.75h9.5a2.75 2.75 0 0 0 2.75-2.75v-6.5a2.75 2.75 0 0 0-2.75-2.75h-9.5Zm7.184 1.5h-7.184c-.69 0-1.25.56-1.25 1.25v6.5c0 .69.56 1.25 1.25 1.25h7.184l-.5-.273a2.75 2.75 0 0 1-1.434-2.414v-3.626a2.75 2.75 0 0 1 1.433-2.414l.5-.273Zm3.566 7.552v-6.104a1 1 0 0 0-1.479-.878l-1.87 1.02a1.25 1.25 0 0 0-.651 1.097v3.626c0 .457.25.878.651 1.097l1.87 1.02a1 1 0 0 0 1.479-.878Z"
  }));
};
SvgEnvelopeIcon.displayName = "EnvelopeIcon";

exports.SvgEnvelopeIcon = SvgEnvelopeIcon;
